module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cfIWV"))).then(() => parcelRequire('hEqeo'));